import React from 'react';
import { useTranslation } from '@blocs.i18n';
import classNames from 'classnames';
import { MediaHelper } from '@blocs.common';
import { PrimaryPhotoTag } from './PrimaryPhotoTag';
import { Media, MediaTypeCodeEnum, SubmissionMedia } from '../../graphql-operations';
import { BasicContainer, FlexRow, PillButton, PrimaryButton } from '../../atoms';

interface EditPrimaryStatusProps {
  mediaItem: Media | SubmissionMedia;
  isSelected: boolean;
  isPrimary: boolean;
  onChangePrimaryStatus?: () => void;
}

export const EditPrimaryStatus = ({
  isSelected,
  isPrimary,
  mediaItem,
  onChangePrimaryStatus,
}: EditPrimaryStatusProps) => {
  const { t } = useTranslation();
  const getMediaText = MediaHelper.useMediaText();

  const isDisabled = !isSelected;
  const mediaType = mediaItem.mediaType.code as MediaTypeCodeEnum;

  const actionButtonText =
    getMediaText(mediaType, isPrimary ? 'removeAsPrimary' : 'setAsPrimaryShort') || t('common:mediaType.media');

  const isVideo = mediaType === MediaTypeCodeEnum.Video;
  const isAudio = mediaType === MediaTypeCodeEnum.Audio;
  const isPrimaryPhoto = isPrimary && mediaType === MediaTypeCodeEnum.Photo;
  const isNonPrimaryPhoto = !isPrimary && mediaType === MediaTypeCodeEnum.Photo;
  return (
    <FlexRow
      className={classNames(!isAudio && 'cn_bottom-0 cn_absolute')}
      justifyContent="center"
      my={isAudio ? '4' : '2'}
      w="full"
      data-testid="primary-status"
    >
      <BasicContainer>
        {isPrimaryPhoto && <PrimaryPhotoTag label={actionButtonText} />}
        {isAudio && (
          <PrimaryButton
            disabled={isDisabled}
            onClick={() => onChangePrimaryStatus?.()}
            startIcon={{ name: 'on-avail', justify: 'start' }}
            label={actionButtonText}
            variant={isPrimary ? 'solid' : 'secondary'}
            className="cn_shadow-md"
            isSmall
          />
        )}
        {(isVideo || isNonPrimaryPhoto) && (
          <PillButton
            disabled={isDisabled}
            onClick={() => onChangePrimaryStatus?.()}
            startIcon={{ name: 'on-avail', justify: 'start' }}
            label={actionButtonText}
            variant={isPrimary ? 'solid' : 'secondary'}
            className="cn_shadow-md"
          />
        )}
      </BasicContainer>
    </FlexRow>
  );
};
